import { render, staticRenderFns } from "./BplSeasonalRating.vue?vue&type=template&id=5f0cf42a&scoped=true"
import script from "./BplSeasonalRating.vue?vue&type=script&lang=js"
export * from "./BplSeasonalRating.vue?vue&type=script&lang=js"
import style0 from "./BplSeasonalRating.vue?vue&type=style&index=0&id=5f0cf42a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0cf42a",
  null
  
)

export default component.exports